import { Typography, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Routes, Route, usePanelHistoryTop } from 'weblite-router'
import { SignIn } from '$comp/signin'
import { SignUp } from '$comp/signup'
import { Verification } from '$comp/verification'
import { AuthStartingPage } from '$comp/auth-starting-page'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { AuthSlider } from '$comp/auth-slider'
import { t } from '$i18n'

const LogoAndTitleContainer = styled('div')`
  position: absolute;
  top: 150px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const PAGES = {
  signIn: SignIn,
  verify: Verification,
  signUp: SignUp,
  startingPage: AuthStartingPage,
  slider: AuthSlider,
}

export function Auth() {
  const { state } = usePanelHistoryTop('root') || {}
  const theme = useTheme()
  return (
    <VisibilityHandler
      style={{
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        background: theme.palette.neutral900,
      }}
      zIndex={1}
    >
      <LogoAndTitleContainer>
        <img
          style={{
            width: '200px',
            height: '100px',
            objectFit: 'cover',
          }}
          src="/assets/icons/jaryan-auth-logo.png"
          alt="jaryan-auth-logo"
        />

        <Typography variant="h3" color="neutral000" textAlign="center">
          {t('auth.title')}
        </Typography>
      </LogoAndTitleContainer>

      <Routes>
        {Object.keys(PAGES).map(page => {
          const Component = PAGES[page as keyof typeof PAGES]
          return (
            <Route key={page} name={page} element={<Component {...state} />} />
          )
        })}
      </Routes>
    </VisibilityHandler>
  )
}

//  TODO: i18n
